import { Breadcrumbs, Container } from '@/components';
import { type IPageOverviewBanner, SectionThemeKey } from '@/interfaces';
import { useRouter } from 'next/router';
import type React from 'react';
import GraphicImg from '../../GraphicImg';
import WidgetTextSection from '../WidgetTextSection';
import { TradeRouteWidgetContainer, TradeRouteWidgetWrapper } from './BannerWithTradeRouteWidget.styles';
import TradeRouteSelector, { type ITradeRoute } from './TradeRouteSelector/TradeRouteSelector';

const BannerWithTradeRouteWidget: React.FC<IPageOverviewBanner> = ({
  breadcrumbs,
  title,
  subText,
  subTextMobile,
  priority,
  image,
  imageMobile,
  theme,
}) => {
  const router = useRouter();

  const handleOnTradelaneSearch = ({ from, to }: ITradeRoute) => {
    const slug = `${from}-to-${to}`;
    router.push(slug);
  };

  return (
    <TradeRouteWidgetContainer sectionTheme={theme || SectionThemeKey.Light}>
      <GraphicImg image={image} imageMobile={imageMobile} priority={priority} />
      <Container style={{ position: 'relative' }}>
        {!!breadcrumbs && <Breadcrumbs {...breadcrumbs} />}
        <WidgetTextSection title={title} mobileSubText={subTextMobile ?? ''} desktopSubText={subText ?? ''} />
      </Container>

      <TradeRouteWidgetWrapper>
        <TradeRouteSelector theme={theme} onSearch={handleOnTradelaneSearch} />
      </TradeRouteWidgetWrapper>
    </TradeRouteWidgetContainer>
  );
};

export default BannerWithTradeRouteWidget;
